import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { Menu, Dropdown, Avatar, Icon, Button, Modal, Select, Tooltip } from 'antd';

import './index.scss';

import { trainYourBot, publishYourBot, whatsAppFileUpload } from '../../data/redux/page_details/actions';
import { changeAgentState } from '../../data/redux/admin_details/actions';
import { getIsEmptyBifurcation } from '../../data/redux/admin_details/selectors';
import { ROUTE_PATH, AGENT_STATUS } from '../../data/config/constants';
import { BRAND_INFO, MODULE_CONFIG } from '../../data/config/urls';
import { log, showMessage } from '../../data/config/utils';

import ErrorBoundary from '../errorboundary';
import Bifurcation from './bifurcation';

const ButtonGroup = Button.Group;

class AppHeader extends React.PureComponent {
  hiddenFileInput = React.createRef(null)

  onClickWhatsappFileUpload = () => {
    this.hiddenFileInput.current.click()
  }

  onChangeFileInput = event => {
    const { whatsAppFileUpload } = this.props.actions
    if (event.target.files[0] && (MODULE_CONFIG.GLOBAL.WHATSAPP_FILE_UPLOAD_ALLOWED_TYPES.indexOf(event.target.files[0].type) > -1)) {
      const selected_file = event.target.files[0]
      const form_data = new FormData()
      form_data.append("file1", selected_file, selected_file.name)
      Modal.confirm({
        title: `Do you want to upload this file (${selected_file.name})?`,
        onOk: () => whatsAppFileUpload(form_data)
      })
    } else
      showMessage('warning', 'File format not allowed')
  }

  clearExistingInput = event => {
    event.target.value = null
  }

  trainBot = () => {
    const { trainYourBot } = this.props.actions;
    Modal.confirm({
      title: "Do you want to train your bot?",
      onOk: trainYourBot
    })
  };

  publishBot = () => {
    const { publishYourBot } = this.props.actions;
    Modal.confirm({
      title: "Do you want to publish your bot?",
      onOk: publishYourBot
    })
  };

  onChangeAgentState = (value, data) => {
    const { changeAgentState } = this.props.actions;
    const payload = data.props.option;
    changeAgentState(payload);
  };

  renderHeaderTitle = () => {
    const { screen_width, current_sider_module } = this.props;
    if (screen_width < 768) {
      return (
        <div className="ori-lr-pad-10 ori-tb-pad-15 ori-flex">
          <img src={BRAND_INFO.logo_url} alt="" className="ori-full-parent-height" />
        </div>
      );
    }
    return (
      <div className=" ori-pad-10 ori-flex-column ori-flex-jc">
        <p className="ori-capitalize ori-font-md ori-l-pad-10">
          {current_sider_module}
        </p>
      </div>
    );
  };

  scrollToChatList = () => {
    const node = document.getElementById('chatList');
    if (node)
      node.scrollIntoView({ behavior: 'smooth' })
  }

  scrollToUserProfile = () => {
    const node = document.getElementById('clientProfile');
    if (node)
      node.scrollIntoView({ behavior: 'smooth' })
  }

  scrollToChatWindow = () => {
    const node = document.getElementById('chatWindow');
    if (node)
      node.scrollIntoView({ behavior: 'smooth' })
  }

  renderAgentKpisInMobile = () => {
    const { agent_live_kpis, history, screen_width } = this.props;
    if (screen_width < 768 && history.location && history.location.pathname === ROUTE_PATH.CHATS && agent_live_kpis) {
      return agent_live_kpis.map(kpi => {
        return (
          <Menu.Item key={kpi.title} className="ori-no-mrgn">
            <div className="ori-flex-row ori-flex-jsb">
              <p className="ori-r-pad-15 ori-font-xs">{kpi.title}</p>
              <div className="ori-font-bold">{kpi.value}</div>
            </div>
          </Menu.Item>
        );
      })
    }
  }

  render() {
    const {
      admin_details,
      bot_training,
      bot_publishing,
      wa_file_uploading,
      agent_states,
      history,
      is_chats_socket_connected,
      agent_live_kpis,
      logout,
      screen_width,
      is_empty_bifurcation
    } = this.props;

    const admin_fname = admin_details.user_info && admin_details.user_info.firstName ? admin_details.user_info.firstName : "unknown"
    const is_mobile = screen_width < 768
    log('AppHeader rendered')
    return (
      <div className={classNames("ori-full-width ori-full-parent-height ori-flex-row ori-flex-jsb oriAppHeaderContainer")}>
        {this.renderHeaderTitle()}
        <div className="headerContentContainer">
          <ul className="ori-no-b-mrgn ori-no-l-pad ori-flex navList">
            {
              !is_mobile && history.location && history.location.pathname === ROUTE_PATH.CHATS && agent_live_kpis && agent_live_kpis.map((kpi, index) => {
                return (
                  <ErrorBoundary key={index}>
                    <li className="ori-flex-column ori-flex-jc navItem">
                      <Tooltip
                        overlayClassName="ori-tooltip-arrow-hidden ori-tooltip-bg-white ori-tooltip-tag"
                        title={kpi.title}
                      >
                        <div className="ori-lr-pad-10 ori-border-green ori-border-radius-4 ori-font-xs ori-flex-column ori-flex-center ori-font-green" style={{ lineHeight: '1.5', height: '24px' }}>
                          {kpi.value}
                        </div>
                      </Tooltip>
                    </li>
                  </ErrorBoundary>
                );
              })
            }
            {
              is_mobile && history.location && (history.location.pathname === ROUTE_PATH.CHATS || history.location.pathname === ROUTE_PATH.CHAT_HISTORY) &&
              <React.Fragment>
                <li className="ori-flex-column ori-flex-jc navItem" onClick={this.scrollToChatList}>
                  <div className="ori-lr-pad-3 ori-font-md">
                    <Icon type='ordered-list' />
                  </div>
                </li>
                <li className="ori-flex-column ori-flex-jc navItem" onClick={this.scrollToUserProfile}>
                  <div className="ori-lr-pad-3 ori-font-md" >
                    <Icon type='user' />
                  </div>
                </li>
                <li className="ori-flex-column ori-flex-jc navItem" onClick={this.scrollToChatWindow}>
                  <div className="ori-lr-pad-3 ori-font-md">
                    <Icon type='edit' />
                  </div>
                </li>
              </React.Fragment>
            }
            {
              admin_details.nlpServiceDetails && (admin_details.nlpServiceDetails.trainFlag || admin_details.nlpServiceDetails.publishFlag) && history.location && history.location.pathname.includes(ROUTE_PATH.BOT_BUILDER) &&
              <li className="navItem">
                <ButtonGroup>
                  {
                    admin_details.nlpServiceDetails.trainFlag &&
                    <Button size="small" className="ori-font-xs ori-lr-pad-10" style={{ lineHeight: '23px' }} loading={bot_training} onClick={this.trainBot}>{bot_training ? 'Training' : 'Train'}</Button>
                  }
                  {
                    admin_details.nlpServiceDetails.publishFlag &&
                    <Button size="small" className="ori-font-xs ori-lr-pad-10" style={{ lineHeight: '23px' }} loading={bot_publishing} onClick={this.publishBot}>{bot_publishing ? 'Publishing' : 'Publish'}</Button>
                  }
                </ButtonGroup>
              </li>
            }
            {
              !is_mobile && history.location && history.location.pathname.includes(ROUTE_PATH.CHAT_HISTORY) && admin_details.user_info && admin_details.user_info.permissions && admin_details.user_info.permissions.events && admin_details.user_info.permissions.events.whatsappFileUpload &&
              <li className="navItem">
                <input
                  type="file"
                  ref={this.hiddenFileInput}
                  onChange={this.onChangeFileInput}
                  accept={MODULE_CONFIG.GLOBAL.WHATSAPP_FILE_UPLOAD_ALLOWED_TYPES}
                  hidden
                  onClick={this.clearExistingInput}
                />
                <Button
                  type="primary"
                  size="small"
                  icon="upload"
                  className="ori-font-xs ori-lr-pad-10"
                  style={{ lineHeight: '23px' }}
                  loading={wa_file_uploading}
                  onClick={this.onClickWhatsappFileUpload}
                >
                  Whatsapp file upload
                </Button>
              </li>
            }
            {
              admin_details.user_info && admin_details.user_info.permissions && admin_details.user_info.permissions.events && admin_details.user_info.permissions.events.stateChange &&
              <li className="navItem">
                <Select
                  size="small"
                  className={classNames(
                    "ori-select ori-font-xs ori-capitalize",
                    {
                      "ori-font-danger": !is_chats_socket_connected,
                      "ori-select-bg-green": is_chats_socket_connected && admin_details.current_state.value === AGENT_STATUS.ACCEPTING,
                      "ori-select-bg-danger": is_chats_socket_connected && admin_details.current_state.value === AGENT_STATUS.NOT_ACCEPTING
                    }
                  )}
                  placeholder="select state"
                  style={{
                    maxWidth: "160px",
                    minWidth: "100px"
                  }}
                  dropdownMatchSelectWidth={false}
                  value={is_chats_socket_connected ? admin_details.current_state.state : "connecting..."}
                  loading={!is_chats_socket_connected}
                  disabled={!is_chats_socket_connected}
                  onChange={this.onChangeAgentState}
                >
                  {
                    agent_states.map((agentState, index) => {
                      return (
                        <Select.Option
                          key={index}
                          option={agentState}
                          disabled={agentState.disabled}
                        >
                          {agentState.state}
                        </Select.Option>
                      );
                    })
                  }
                </Select>
              </li>
            }
            {
              !is_empty_bifurcation && !is_mobile &&
              <Bifurcation />
            }
            <li className="navItem">
              <Dropdown
                overlay={
                  <Menu>
                    {
                      is_mobile &&
                      <Menu.Item key="user" className="ori-no-mrgn ori-font-md ori-font-primary ori-font-bold">
                        Hi {admin_fname}
                      </Menu.Item>
                    }
                    {this.renderAgentKpisInMobile()}
                    {
                      is_mobile && admin_details.user_info && admin_details.user_info.permissions && admin_details.user_info.permissions.events && admin_details.user_info.permissions.events.whatsappFileUpload &&
                      <Menu.Item
                        key="whatsappFileUpload"
                        className="ori-no-mrgn"
                        onClick={this.onClickWhatsappFileUpload}
                      >
                        <input
                          type="file"
                          ref={this.hiddenFileInput}
                          onChange={this.onChangeFileInput}
                          accept={MODULE_CONFIG.GLOBAL.WHATSAPP_FILE_UPLOAD_ALLOWED_TYPES}
                          hidden
                          onClick={this.clearExistingInput}
                        />
                        <Icon
                          type={wa_file_uploading ? "loading" : "upload"}
                          className="ori-r-pad-5"
                        />
                        WA File Upload
                    </Menu.Item>
                    }
                    {
                      is_mobile && !is_empty_bifurcation &&
                      <Bifurcation mobile_view />
                    }
                    <Menu.Item key="logout" className="ori-no-mrgn" onClick={logout}>
                      <Icon type="logout" className="ori-r-pad-5" /> Logout
                  </Menu.Item>
                  </Menu>
                }
                placement="bottomRight"
                trigger={['click']}
                style={{ display: 'flex' }}
              >
                <div>
                  <Avatar className="ori-bg-primary ori-capitalize" >{admin_fname.charAt(0)}</Avatar>
                  {
                    !is_mobile &&
                    <span className="ori-mobile-hidde ori-capitalize ori-l-pad-5 ori-font-medium">
                      {admin_fname}
                    </span>
                  }
                </div>
              </Dropdown>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    is_chats_socket_connected: state.chats_details.is_socket_connected,
    admin_details: state.admin_details,
    screen_width: state.page_details.device_data.screen_width,
    current_sider_module: state.page_details.current_sider_module,
    bot_training: state.page_details.loaders.bot_training,
    bot_publishing: state.page_details.loaders.bot_publishing,
    wa_file_uploading: state.page_details.loaders.wa_file_uploading,
    agent_states: state.page_details.agent_states,
    agent_live_kpis: state.kpi_details.agent_live_kpis,
    is_empty_bifurcation: getIsEmptyBifurcation(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        trainYourBot,
        publishYourBot,
        changeAgentState,
        whatsAppFileUpload
      },
      dispatch
    )
  };
};

AppHeader.propTypes = {
  admin_details: PropTypes.object,
  is_chats_socket_connected: PropTypes.bool,
  screen_width: PropTypes.number,
  current_sider_module: PropTypes.string,
  bot_training: PropTypes.bool,
  bot_publishing: PropTypes.bool,
  wa_file_uploading: PropTypes.bool,
  agent_states: PropTypes.array,
  logout: PropTypes.func,
  actions: PropTypes.object,
  history: PropTypes.object,
  agent_live_kpis: PropTypes.array,
  is_empty_bifurcation: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(AppHeader);



// WEBPACK FOOTER //
// ./src/components/appheader/index.js